<script setup lang="ts">
  import { useTemplateRef } from 'vue'
  import {
    Button,
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    ModalSectionHeaderDescription
  } from '@gat-ship/vue-components'
  import { IconPlus } from '@gat-ship/icons'
  import {
    PortCallTypesList,
    PortCallTypesProvider
  } from '@gat-ship/portcall-types'

  const list = useTemplateRef<InstanceType<typeof PortCallTypesList>>('list')

  function openAdd() {
    list.value?.openAdd()
  }
</script>

<template>
  <PortCallTypesProvider>
    <!-- pt-3 offsets the modal's -mt-3 under-fade pull so the header and add
         button start below the fade; once scrolled, content still slides under
         it. pb-5 keeps the last row off the modal edge. -->
    <div class="flex flex-col gap-6 pb-5 pt-3">
      <ModalSection>
        <div class="flex items-start justify-between gap-4">
          <ModalSectionHeader class="pt-1">
            <ModalSectionHeaderTitle> Portcall types </ModalSectionHeaderTitle>
            <ModalSectionHeaderDescription>
              Classifications selected when creating a port call (e.g. Cruise,
              Cargo operations, Repairs). Manage the list available across the
              tenant.
            </ModalSectionHeaderDescription>
          </ModalSectionHeader>
          <Button class="shrink-0" @click="openAdd">
            <IconPlus class="size-4" />
            Add portcall type
          </Button>
        </div>
        <PortCallTypesList ref="list" />
      </ModalSection>
    </div>
  </PortCallTypesProvider>
</template>
